import state from "./state";
import { defaultProducto1, defaultProducto2, defaultResultadoCompatibilidad, defaultUNProductos, defaultSelectedSga, defaultFiltroPagos, defaultFiltrosProductosComparados, defaultFiltersHistory } from './state';

/**
 * Mutación para cargar las empresas registradas
 *
 * @export
 * @param {*} state
 * @param {*} empresas
 */
export function setListaEmpresa(state, empresas) {
    state.empresas = empresas.data;
}

/**
 * Mutación para cargar los resultados de compatibilidad para la empresa seleccionada
 *
 * @export
 * @param {*} state
 * @param {*} listadoResultados
 */
export function setListarResultados(state, listadoResultados) {
    state.listadoResultados = listadoResultados.data;
    state.total.resultados = listadoResultados.total;
}

/**
 * Mutación para cambiar el número de registros por página
 *
 * @export
 * @param {*} state
 * @param {*} productos
 */
export function setPerPage(state, perPage) {
    if (perPage.tipo == 'productosPagos') {
        state.filtroProductosPagos.perPage = perPage.cantidad;
    } else if (perPage.tipo == 'resultadosMatriz') {
        state.filtroResultados.perPage = perPage.cantidad;
    } else {
        state.filtroProductosComparados.perPage = perPage.cantidad;
    }
}

/**
 * Mutación para cambiar de página en la paginación
 *
 * @export
 * @param {*} state
 * @param {*} productos
 */
 export function setPage(state, page) {
    if (page.tipo == 'productosPagos') {
        state.filtroProductosPagos.page = page.cantidad;
    } else if (page.tipo == 'resultadosMatriz') {
        state.filtroResultados.page = page.cantidad;
    } else {
        state.filtroProductosComparados.page = page.cantidad;
    }
}

/**
 * Mutación para asignar los productos de la empresa
 *
 * @export
 * @param {*} state
 * @param {*} productos
 */
export function setProductos(state, productos) {
    productos.data.data.map(prod => {
        if (prod.id == state.producto1.id) {
            Object.assign(prod, {checked1: true});
            Object.assign(prod, {checked2: false});
        }

        if (prod.id == state.producto2.id) {
            Object.assign(prod, {checked1: false});
            Object.assign(prod, {checked2: true});
        }

        if (prod.id == state.producto1.id && prod.id == state.producto2.id) {
            Object.assign(prod, {checked1: false});
            Object.assign(prod, {checked2: false});
        }
    });
    state.selectedEmpresa.productos = productos.data.data;
    state.total.productosPagos = productos.data.total;
}

/**
 * Mutación para asignar la información general del producto 1
 *
 * @export
 * @param {*} state
 * @param {*} paso
 */
export function setProducto1(state, data) {
    Object.assign(state.producto1, data);
}

/**
 * Mutación para asignar la información general del producto 2
 *
 * @export
 * @param {*} state
 * @param {*} paso
 */
export function setProducto2(state, data) {
    Object.assign(state.producto2, data);
}

/**
 * Mutación para asignar el paso a seguir del formulario de la matriz de compatibilidad
 *
 * @export
 * @param {*} state
 * @param {*} paso
 */
export function setPaso(state, paso) {
    state.paso = paso;
}

/**
 * Mutación para limpiar los campos del formulario cuando se deselecciona un producto ingresado
 *
 * @export
 * @param {*} state
 * @param {*} n
 */
export function limpiarCamposProductoIngresado(state, n) {
    if (n === 1) {
        let indice = state.selectedEmpresa.productos.findIndex(i => i.id === state.producto1.id);
        if (indice != -1) {
            state.producto1.estado_id = state.selectedEmpresa.productos[indice].estado;
            state.producto1.estado_texto = state.selectedEmpresa.productos[indice].lista_estado.lista;
            state.producto1.fabricante_id = state.selectedEmpresa.productos[indice].fabricante != null ? state.selectedEmpresa.productos[indice].fabricante.id : '';
            state.producto1.fabricante_texto = state.selectedEmpresa.productos[indice].fabricante != null ? state.selectedEmpresa.productos[indice].fabricante.nombre : '';
            state.producto1.nombre = '';
        } else {
            state.producto1.estado_id = '';
            state.producto1.estado_texto = '';
            state.producto1.fabricante_id = '';
            state.producto1.fabricante_texto = '';
        }
    } else {
        let indice = state.selectedEmpresa.productos.findIndex(i => i.id === state.producto2.id);
        if (indice != -1) {
            state.producto2.estado_id = state.selectedEmpresa.productos[indice].estado;
            state.producto2.estado_texto = state.selectedEmpresa.productos[indice].lista_estado.lista;
            state.producto2.fabricante = state.selectedEmpresa.productos[indice].fabricante != null ? state.selectedEmpresa.productos[indice].fabricante.id : '';
            state.producto2.fabricante_texto = state.selectedEmpresa.productos[indice].fabricante != null ? state.selectedEmpresa.productos[indice].fabricante.nombre : '';
            state.producto2.nombre = '';
        } else {
            state.producto2.estado_id = '';
            state.producto2.estado_texto = '';
            state.producto2.fabricante_id = '';
            state.producto2.fabricante_texto = '';
        }
    }
}

/**
 * Mutación para limpiar las naciones unidas de ambos productos
 *
 * @export
 * @param {*} state
 */
export function resetUNProductos(state) {
    Object.assign(state.producto1, defaultUNProductos());
    Object.assign(state.producto2, defaultUNProductos());
}

/**
 * Mutación para limpiar los filtros de búsqueda del formulario general de la matriz
 *
 * @export
 * @param {*} state
 */
export function resetFiltroProductosPagos(state) {
    Object.assign(state.filtroProductosPagos, defaultFiltroPagos());
}

/**
 * Mutación para limpiar los filtros de búsqueda del formulario de productos comparados
 *
 * @export
 * @param {*} state
 */
export function resetFiltroProductosComparados(state) {
    Object.assign(state.filtroProductosComparados, defaultFiltrosProductosComparados());
}

/**
 * Mutación para determinar el tipo de matriz que se está consultando
 *
 * @export
 * @param {*} state
 * @param {*} tipoMatriz contiene un string con el tipo de matriz
 */
export function setTipoMatriz(state, tipoMatriz) {
  state.tipoMatriz.tipo = tipoMatriz;
}

/**
 * Mutación para limpiar el sga de ambos productos
 *
 * @export
 * @param {*} state
 */
export function limpiarSga(state) {
    state.producto1.selectedSga = [];
    state.producto1.pictogramas = [];
    state.producto1.sinPictograma = false;
    state.producto2.selectedSga = [];
    state.producto2.pictogramas = [];
    state.producto2.sinPictograma = false;
}

/**
 * Mutación para almacenar el nombre de la empresa seleccionada
 *
 * @export
 * @param {*} state
 * @param {*} empresa contiene la información de la empresa
 */
export function setEmpresa(state, empresa) {
    Object.assign(state.selectedEmpresa, empresa);
}

/**
 * Mutación para asignar el sga los productos de la matriz
 *
 * @export
 * @param {*} state
 * @param {*} sga contiene la información del sga y el indice del producto
 */
export function setSelectedSga(state, sga) {
    if (sga.index == 1) {
        state.producto1.selectedSga = sga.values;
    } else {
        state.producto2.selectedSga = sga.values;
    }
}

/**
 * Mutación para asignar o designar un producto en el formulario de generación de matriz
 *
 * @export
 * @param {*} state
 * @param {*} data
 */
export function setProductoGenerarMatriz(state, data) {
    if (data.checked) {
        state.productosGenerarMatriz.push(data.producto);
    } else {
        state.productosGenerarMatriz.forEach((p, index, object) => {
            if (p.id == data.producto.id && p.id_producto == data.producto.id_producto) {
                object.splice(index, 1);
            }
        });
    }
}

/**
 * Mutación para limpiar los campos de lformulario cuando se borra el nombre de un nuevo producto
 *
 * @export
 * @param {*} state
 * @param {*} n
 */
export function limpiarCampoProductoNuevo(state, n) {
    if (n === 1 && state.producto1.nombre === '') {
        state.producto1.estado_id = '';
        state.producto1.estado_texto = '';
        state.producto1.fabricante_id = '';
        state.producto1.fabricante_texto = '';
    } else if (n === 2 && state.producto1.nombre === '') {
        state.producto2.estado_id = '';
        state.producto2.estado_texto = '';
        state.producto2.fabricante_id = '';
        state.producto2.fabricante_texto = '';
    }
}
/**
 * Mutación para cargar las preguntas asociadas a la empresa
 *
 * @export
 * @param {*} state
 * @param {*} preguntas
 */
 export function setPreguntasEmpresa(state, preguntas) {
    state.preguntas = preguntas;
}

/**
 * Mutación para cargar los resultados asociadas a la empresa
 *
 * @export
 * @param {*} state
 * @param {*} preguntas
 */
export function setResultadosEmpresa(state, resultados) {
    state.resultados = resultados;
}

/**
 * Mutación para cargar las preguntas obtenidas en base a los peligros seleccionados
 *
 * @export
 * @param {*} state
 * @param {*} preguntas
 */
export function setPreguntas(state, preguntas) {
    preguntas.forEach(p => {
        p.respuesta = '';
    });
    state.preguntas = preguntas;
}

/**
 * Mutación para determinar si la peligrosidad de ambos productos químicos son iguales
 *
 * @export
 * @param {*} state
 * @param {*} preguntas
 */
 export function setCompatibilidadUN(state, compatibilidad_un) {
    state.compatibilidad_un = compatibilidad_un;
}

/**
 * Mutación para guardar el resultado de la compatibilidad de los productos ingresados
 *
 * @export
 * @param {*} state
 * @param {*} modalMatriz
 */
 export function setResultadoCompatibilidad(state, resultado) {
    state.resultadoCompatibilidad = {
        key: resultado.codigo,
        text: resultado.resultado,
        color: resultado.color
    }
}

/**
 * Mutación que carga los riesgos principales en el formulario.
 *
 * @param {*} state contiene la información de variables del formulario.
 * @param {*} optprincipal contiene la información de riesgos principales.
 */
 export function setRiesgoPrincipal(state, optprincipal) {
    state.optprincipal = [];

    for (var i = 0; i < optprincipal.length; i++) {
        let descripcion = optprincipal[i].codigo;

        if (optprincipal[i].codigo != optprincipal[i].descripcion) {
            descripcion += ' ' + optprincipal[i].descripcion;
        }
        state.optprincipal.push({ value: optprincipal[i].id, text: descripcion, imagen: optprincipal[i].imagen });
    }
}

/**
 * Mutación que carga los riesgos secundarios en el formulario.
 *
 * @param {*} state contiene la información de variables del formulario.
 * @param {*} optsecundario contiene la información de riesgos secundarios.
 */
export function setRiesgoRiesgoSecundario(state, optsecundario) {
    state.optsecundario = [];

    for (var i = 0; i < optsecundario.length; i++) {
        let descripcion = optsecundario[i].codigo;

        if (optsecundario[i].codigo != optsecundario[i].descripcion) {
            descripcion += ' ' + optsecundario[i].descripcion;
        }
        state.optsecundario.push({ value: optsecundario[i].id, text: descripcion, imagen: optsecundario[i].imagen });
    }
}

/**
 * Mutación que limpiar la empresa seleccionada
 *
 * @param {*} state contiene la información de variables del formulario.
 */
export function limpiarEmpresa(state) {
    let empresa = {id: '', productos: [] }
    state.selectedEmpresa = empresa;
}

/**
 * Mutación que carga los riesgos secundarios1 en el formulario.
 *
 * @param {*} state contiene la información de variables del formulario.
 * @param {*} optsecundario1 contiene la información de riesgos secundarios1.
 */
export function setRiesgoRiesgoSecundario1(state, optsecundario1) {
    state.optsecundario1 = [];

    for (var i = 0; i < optsecundario1.length; i++) {
        let descripcion = optsecundario1[i].codigo;

        if (optsecundario1[i].codigo != optsecundario1[i].descripcion) {
            descripcion += ' ' + optsecundario1[i].descripcion;
        }
        state.optsecundario1.push({ value: optsecundario1[i].id, text: descripcion, imagen: optsecundario1[i].imagen });
    }
}

/**
 * Mutación para cargar adjunto guardado en la matriz
 *
 * @export
 * @param {*} state
 * @param {*} modalMatriz
 */
export function setAdjuntosProducto(state, data) {
    if (data.producto == 1) {
        let adjunto = {'adjunto': data.adjunto};
        state.producto1.adjuntos.push(adjunto);
    } else {
        let adjunto = {'adjunto': data.adjunto};
        state.producto2.adjuntos.push(adjunto);
    }
}


/**
 * Mutación para limpiar toda la información ingresada
 *
 * @export
 * @param {*} state
 * @param {*} modalMatriz
 */
export function resetProductos(state) {
    Object.assign(state.producto1, defaultProducto1());
    Object.assign(state.producto2, defaultProducto2());
    state.preguntas = [];
    state.compatibilidad_un = 0;
    Object.assign(state.homologacion_SGA, '');
    Object.assign(state.homologacion_UN, '');
}

/**
 * Mutación para limpiar el resultado de compatibilidad
 *
 * @export
 * @param {*} state
 * @param {*} modalMatriz
 */
export function limpiarResultado(state) {
    Object.assign(state.resultadoCompatibilidad, defaultResultadoCompatibilidad());
}

/**
 * Mutación para guardar las Naciones Unidas o el SGA de los productos ingresados
 *
 * @export
 * @param {*} state
 * @param {*} UNSga
 */
export function setUNSga(state, UNSga) {
    let data = UNSga.data;
    if (data.UNProducto) {
        const UN = {
            noun: data.UNProducto.noun,
            riesgo_principal: data.UNProducto.txtprincipal,
            riesgo_secundario: data.UNProducto.txtsecundario,
            riesgo_secundario1: data.UNProducto.txtsecundario1,
            imagen_principal: data.UNProducto.imagen_principal,
            imagen_secundario: data.UNProducto.imagen_secundario,
            imagen_secundario1: data.UNProducto.imagen_secundario1
        }

        if (state.producto1.id === parseInt(data.id_producto)) {
            Object.assign(state.producto1, UN);
        }
        if (state.producto2.id === parseInt(data.id_producto)) {
            Object.assign(state.producto2, UN);
        }
        state.homologacion_UN = 1;
    }

    if (data.SGAProducto) {
        if (state.producto1.id === parseInt(data.id_producto)) {
            if (data.SGAProducto.Clasificacion) {
                let pictos = [];
                for (let z = 0; z < data.SGAProducto.Clasificacion.length; z++) {
                    pictos.push(data.SGAProducto.Clasificacion[z]);
                }
                state.producto1.pictogramas = pictos;
            } else {
                state.producto1.sinPictograma = true;
            }
        }
        if (state.producto2.id === parseInt(data.id_producto)) {
            if (data.SGAProducto.Clasificacion) {
                let pictos = [];
                for (let z = 0; z < data.SGAProducto.Clasificacion.length; z++) {
                    pictos.push(data.SGAProducto.Clasificacion[z]);
                }
                state.producto2.pictogramas = pictos;
            } else {
                state.producto2.sinPictograma = true;
            }
        }
        state.homologacion_SGA = 1;
    }
}

/**
 * Mutación para limpiar la información de Naciones Unidas y SGA
 *
 * @export
 * @param {*} state
 * @param {*} UNSga
 */
export function limpiarUNSga() {
    state.producto1.pictogramas = {};
    state.producto2.pictogramas = {};
}

/**
 * Mutación para obtener los productos comparados por empresa
 *
 * @export
 * @param {*} state
 * @param {*} UNSga
 */
export function setProductosComparados(state, productos) {
    productos.data.forEach((p, index, object) => {
        state.productosGenerarMatriz.forEach((g) => {
            if (g.id == p.id && g.id_producto == p.id_producto && g.fabricante == p.fabricante && g.nombre == p.nombre && g.estado == p.estado) {
                object[index].checked = true;
            }
        });
    });
    state.productosComparados = productos.data;
    state.total.productosComparados = productos.total;
}

/**
 * Mutación para setear la empresa seleccionada
 *
 * @param {*} state
 * @param {*} company_id
 * @author Brandon Torres
*/
export function setCompany(state, company_id) {
    state.company_id = company_id;
}

/**
 * Mutación para setear el control de la matriz
 *
 * @param {*} state
 * @param {*} controlMatriz
 * @author Brandon Torres
*/
export function setControlMatriz(state, controlMatriz) {
    state.controlMatriz = controlMatriz;
}

/**
 * Mutación para setear el historico de la matriz
 *
 * @param {*} state
 * @param {*} history
 * @return {void}
 */
export function setHistory(state, history) {
    state.history = history;
}

/**
 * Mutación para limpiar el filtro del historico de la matriz
 *
 * @param {*} state
 * @return {void}
 */
export function setDefaultFiltersHistory(state) {
    state.filtersHistory = defaultFiltersHistory();
}

/**
 * Mutación que establece la cantidad de historiales por página.
 *
 * @param per_page - Cambio de cantidad de registros por página.
 * @param {*} state.filtersHistory.per_page - Cantidad de registros por página.
 * @param {*} state.filtersHistory.page - Página actual.
 * @return {void}
 * @author Brandon Torres
 */
export function loadAfterChangeSizePagination(state, per_page) {
    state.filtersHistory = {
        ...state.filtersHistory,
        page: 1,
        per_page: per_page,
    };
}

/**
 * Mutación que establece la página actual.
 *
 * @param page - Cambio de página actual.
 * @param {*} state.filtersHistory.page - Página actual.
 * @return {void}
 * @author Brandon Torres
 */
export function loadAfterChangePagePagination(state, page) {
    state.filtersHistory.page = page;
}

/**
 * Mutación que establece el paginador de registros de historiales.
 *
 * @param paginate - Paginación de registros.
 * @param {*} state.filtersHistory.page - Página actual.
 * @param {*} state.filtersHistory.per_page - Cantidad de registros por página.
 * @param {*} state.filtersHistory.total - Total de registros.
 * @return {void}
 * @author Brandon Torres
 */
export function setPaginateHistory(state, paginate) {
    state.filtersHistory = {
        ...state.filtersHistory,
        page: paginate.current_page,
        per_page: paginate.per_page,
        total: paginate.total,
    };
}
